import type {} from '@angular/localize/init';
import { appRoutesI18nCache } from '../i18n-cache';

export function resultsCenterRouteI18n(): string {
  return (appRoutesI18nCache['results-center'] ??= $localize`:url-segment@@results-center-url-segment:results-center`);
}
